import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { FeedbackModal, Provider } from "../components";
import { RootStore } from "../store";
function listenPluginDeactivation() {
    document.addEventListener("click", (e)=>{
        const { names, currentUserFullName } = RootStore.get.optionStore.others;
        const link = e == null ? void 0 : e.target;
        for(const slug in names){
            const { plugin, hasAtLeastOneActiveLicense, isPluginActiveForNetwork } = names[slug];
            if (link.matches(`tr[data-plugin="${plugin}"] a[href*="action=deactivate"]`)) {
                const node = document.createElement("div");
                document.body.appendChild(node);
                const root = createRoot(node);
                root.render(/*#__PURE__*/ _jsx(Provider, {
                    children: /*#__PURE__*/ _jsx(FeedbackModal, {
                        ...names[slug],
                        initialValues: {
                            name: currentUserFullName
                        },
                        plugin: slug,
                        hasAtLeastOneActiveLicense: hasAtLeastOneActiveLicense,
                        isPluginActiveForNetwork: isPluginActiveForNetwork,
                        onClose: ()=>{
                            root.unmount();
                        },
                        onDeactivate: ()=>{
                            window.location.href = link.href;
                        }
                    })
                }));
                e.preventDefault();
                // Stop `real-utils` functionality
                e.stopImmediatePropagation();
                break;
            }
        }
    }, true);
}
export { listenPluginDeactivation };
